import logo from '../../../assets/images/svg/viettel-media.svg';
import Facebook from './connect/facebook';
import Instagram from './connect/instagram';
import Zalo from './connect/zalo';
import Shopee from './connect/shopee';
import MainChannel from '../../shared/main-channel';

const Channel = () => {
   return (
      <div className="app-connect-channel--container">
         <div className="app-sh-connect-channel--body">
            <div className="app-connect-channel--header">
               <div className="app-connect-channel--header-logo">
                  <a href="">
                     <img src={logo} />
                  </a>
               </div>
               <div className="app-connect-channel--header-content">
                  Kết nối kênh hỗ trợ &amp; tư vấn bán hàng
               </div>
            </div>
            <div className="app-sh-connect-channel--body-content">
               <div className="app-sh-connect-channel--list">
                  <Facebook />
                  {/* <Instagram />
                     <Zalo />
                     <Shopee /> */}
               </div>
               <div className="app-sh-connect-channel-body-content-policies">
                  Nhấn vào nút "Thêm kết nối" đồng nghĩa với việc bạn đồng ý với các
                  <a href="" target="_blank">
                     điều khoản dịch vụ
                  </a>
                  và
                  <a href="" target="_blank">
                     chính sách bảo mật
                  </a>
                  của Viettel Media.
               </div>
               <div className="app-sh-connect-channel-body--badge">
               </div>
            </div>
         </div>
      </div>
   )
}


export default Channel;
